/// <reference path="../../include.ts" />

namespace gpx_visualizer_phase2 {

	import View = alm.view.View;

	export class BoundingBox extends View<THREE.Object3D> {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(center:THREE.Vector2, sizeX:number, sizeZ:number) {
			super(new THREE.Object3D());

			this.center = center;
			this.sizeX = sizeX;
			this.sizeZ = sizeZ;

			this.initialize();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implInitialize():THREE.Object3D {
			const view = this.getView();

			const boundsTLPixel:THREE.Vector2 = new THREE.Vector2(this.center.x - this.sizeX * 0.5, this.center.y - this.sizeZ * 0.5);
			const boundsBRPixel:THREE.Vector2 = new THREE.Vector2(this.center.x + this.sizeX * 0.5, this.center.y + this.sizeZ * 0.5);

			const assetLoader = AssetLoader.getInstance();
			const zoomLevel = assetLoader.getMeta().getZoomLevel();
			const minElevation = assetLoader.getDem().getMinElevation();

			const bottomOffsetMeter = 0;
			const bottomOffsetPixel = -5;
			const bottomY:number = Unit.meterToPixel(Math.min(0, minElevation) + bottomOffsetMeter, zoomLevel) + bottomOffsetPixel;
			const bottomRects:THREE.Vector3[] = [
				new THREE.Vector3(boundsTLPixel.x, bottomY, boundsTLPixel.y),
				new THREE.Vector3(boundsBRPixel.x, bottomY, boundsTLPixel.y),
				new THREE.Vector3(boundsTLPixel.x, bottomY, boundsBRPixel.y),
				new THREE.Vector3(boundsBRPixel.x, bottomY, boundsBRPixel.y),
			];

			{
				const material:THREE.LineBasicMaterial = new THREE.LineBasicMaterial({
					color: 0xffffff,
					opacity: 0.2, //0.4,
					transparent: true,
					linewidth: 1
				});

				/*
				const assetLoader = AssetLoader.getInstance();
				const sizeY:number = Unit.meterToPixel(assetLoader.getDem().getMaxElevation() + 2000, assetLoader.getMeta().getZoomLevel()) * Config.terrainElevationMaxScale;

				const geometry:THREE.EdgesGeometry = new THREE.EdgesGeometry(new THREE.BoxBufferGeometry(this.sizeX, sizeY, this.sizeZ));

				const view = new THREE.LineSegments(geometry, material);
				view.position.set(this.center.x, sizeY * 0.5, this.center.y);
				return view;
				*/

				const geometry:THREE.Geometry = new THREE.Geometry();

				// bottom plane
				geometry.vertices.push(bottomRects[0]);
				geometry.vertices.push(bottomRects[1]);

				geometry.vertices.push(bottomRects[2]);
				geometry.vertices.push(bottomRects[3]);

				geometry.vertices.push(bottomRects[1]);
				geometry.vertices.push(bottomRects[3]);

				geometry.vertices.push(bottomRects[0]);
				geometry.vertices.push(bottomRects[2]);

				// pole
				const assetLoader = AssetLoader.getInstance();
				const meta:Meta = assetLoader.getMeta();
				const dimensionX:number = meta.getDemDimensionX();
				const dimensionY:number = meta.getDemDimensionY();
				const dem:Dem = assetLoader.getDem();
				const elevations:number[] = dem.getElevations();
				const zoomLevel:number = meta.getZoomLevel();

				const edgeElevations:number[] = [
					elevations[0],
					elevations[dimensionX - 1],
					elevations[dimensionX * (dimensionY - 1) + 1],
					elevations[dimensionX * dimensionY - 1],
				];

				for (let i = 0; i < 4; ++i) {
					geometry.vertices.push(bottomRects[i]);
					geometry.vertices.push(this.getTopEdgePosition(bottomRects[i], edgeElevations[i], zoomLevel));
				}

				this.line = new THREE.LineSegments(geometry, material);
				view.add(this.line);
			}

			{
				const material = new THREE.MeshBasicMaterial({ color: 0x161616 /* 0x222222 */ });
				const geometry = new THREE.PlaneGeometry(this.sizeX, this.sizeZ);
				this.floor = new THREE.Mesh(geometry, material);
				this.floor.rotateX(Math.PI / 2);
				this.floor.rotateY(Math.PI);
				this.floor.position.set(this.center.x, bottomY, this.center.y);

				view.add(this.floor);
			}

			return view;
		}

		private getTopEdgePosition(bottom:THREE.Vector3, elevation:number, zoomLevel:number):THREE.Vector3 {
			return Unit.pixelElevationToSpace(new THREE.Vector2(bottom.x, bottom.z), elevation, zoomLevel);
		}

		protected implReady():void {
		}

		protected implFinalize():void {
		}

		protected implShow(view:THREE.Object3D, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				view.visible = true;
			});
		}

		protected implHide(view:THREE.Object3D, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				view.visible = false;
			});
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private center:THREE.Vector2;
		private sizeX:number;
		private sizeZ:number;

		private line:THREE.LineSegments;
		private floor:THREE.Mesh;
	}
}
